import type { StaffRole } from "@lafayette/auth";
import { useMemo } from "react";

import { type CapabilityRules, capabilityFlags } from "../access/capabilities";
import { useStaffRoles } from "../access/use-staff-roles";

// What a staff member may do in the privacy screens. Presentation only: the API decides every request again. The roles come from the
// domain's `capabilityRoles`.

export type PrivacyCapabilities = Readonly<{
  read: boolean;
  request: boolean;
  approve: boolean;
  downloadExport: boolean;
}>;

const privacyCapabilityRules = {
  read: "privacy.read",
  request: "privacy.request",
  approve: "privacy.approve",
  downloadExport: "privacy.download_export",
} as const satisfies CapabilityRules;

export function privacyCapabilitiesForRoles(roles: readonly StaffRole[]): PrivacyCapabilities {
  return capabilityFlags(privacyCapabilityRules, roles);
}

export function usePrivacyCapabilities(): Readonly<{
  capabilities: PrivacyCapabilities;
  isLoading: boolean;
}> {
  const { roles, isLoading } = useStaffRoles();
  const capabilities = useMemo(() => privacyCapabilitiesForRoles(roles), [roles]);
  return { capabilities, isLoading };
}
